<template>
  <div class="admission-detail-container">
    <h2 class="page-title">{{ schoolname }}招生信息详情</h2>

    <!-- 加载状态 -->
    <div v-if="loading" class="loading">
      <el-icon><Loading /></el-icon> 正在加载招生信息...
    </div>

    <!-- 数据为空提示 -->
    <div
      v-else-if="!admissionData || admissionData.length === 0"
      class="no-data"
    >
      暂无招生信息
    </div>

    <!-- 招生信息列表 -->
    <div v-else class="admission-list">
      <div class="admission-card" v-for="item in admissionData" :key="item.id">
        <div class="year-label">年份: {{ item.year }}</div>
        <div class="image-container">
          <img
            :src="baseURL + item.imgurl"
            alt="招生信息图片"
            class="admission-image"
          />
        </div>
      </div>
    </div>

    <!-- 返回按钮 -->
    <div class="back-btn">
      <el-button @click="goBack">← 返回列表</el-button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getSchoolStudentInfo } from "@/api/schoolApi";
import { baseURL } from "@/api/axiosConfig";

const route = useRoute();
const router = useRouter();
const schoolId = route.params.id;

const fromPage = parseInt(route.query.page) || 1;
const fromFilters = {
  province: route.query.province || "",
  schoolType: route.query.schoolType || "",
  gender: route.query.gender || "",
  examPlaceProvince: route.query.examPlaceProvince || "",
};

const admissionData = ref([]);
const schoolname = ref(""); // 新增 schoolName 变量
const loading = ref(true);

onMounted(async () => {
  if (!schoolId) {
    ElMessage.error("参数错误：缺少学校ID");
    return;
  }
  try {
    const res = await getSchoolStudentInfo(schoolId);
    console.log("API Response Data:", res.data.data); // 打印返回数据
    if (res.data.code === 200) {
      //赋值
      admissionData.value = res.data.data || [];
      schoolname.value = res.data.data[0].schoolname || "未知大学"; // 假设 API 返回 schoolname 字段
      // console.log("admissionData:", admissionData.value);
    } else {
      ElMessage.error("获取招生信息失败：" + res.data.msg);
    }
  } catch (error) {
    ElMessage.error("网络错误，请重试");
    console.error(error);
  } finally {
    loading.value = false;
  }
});
// 返回按钮点击事件
const goBack = () => {
  router
    .push({
      name: "SchoolList",
      query: {
        page: fromPage,
        province: fromFilters.province,
        schoolType: fromFilters.schoolType,
        gender: fromFilters.gender,
        examPlaceProvince: fromFilters.examPlaceProvince,
        tab: "require", // 跳转到招生信息标签页
      },
    })
    .then(() => {
      window.scrollTo(0, 0); // 页面跳转后滚动到顶部
    });
};
// 图片加载失败处理
const handleImageError = (e) => {
  // e.target.src = require("@/assets/default-avatar.png"); // 默认头像兜底
};
</script>

<style scoped>
.admission-detail-container {
  max-width: 900px;
  margin: 50px auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.page-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 30px;
}

.loading,
.no-data {
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 16px;
}

.admission-list {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.admission-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 20px;
  background-color: #f9f9f9;
  transition: box-shadow 0.3s ease;
}

.admission-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.year-label {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
}

.image-container {
  width: 100%;
  max-width: 900px;
  display: flex;
  justify-content: center;
}

.admission-image {
  width: 100%;
  max-width: 900px;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.back-btn {
  margin-top: 40px;
  text-align: center;
}
</style>
